// Fetch instrumentation also records request URLs in breadcrumbs, errors, and spans.
// Strip signed query strings before telemetry is stored or sent to Sentry.
export function redactStorageUrls<T>(value: T): T {
  const seen = new WeakMap<object, unknown>();
  const redact = (item: unknown): unknown => {
    if (typeof item === 'string') {
      if (
        !item.includes('://') &&
        /(?:^|[?&])(?:X-Goog-(?:Algorithm|Credential|Signature)|GoogleAccessId|token)=/i.test(item)
      ) {
        return '[redacted signed query]';
      }
      return item.replace(/https?:\/\/[^\s"'<>]+/g, (url) =>
        /[?&](?:X-Goog-(?:Algorithm|Credential|Signature)|GoogleAccessId|token)=/i.test(url) ? url.split('?')[0] : url,
      );
    }
    if (!item || typeof item !== 'object') return item;
    if (seen.has(item)) return seen.get(item);
    if (Array.isArray(item)) {
      const result: unknown[] = [];
      seen.set(item, result);
      item.forEach((entry) => result.push(redact(entry)));
      return result;
    }
    if (Object.getPrototypeOf(item) !== Object.prototype) return item;
    const result: Record<string, unknown> = {};
    seen.set(item, result);
    Object.entries(item).forEach(([key, entry]) => {
      result[key] = redact(entry);
    });
    return result;
  };
  return redact(value) as T;
}
